import { render, staticRenderFns } from "./SedesFilter.vue?vue&type=template&id=310d74f4"
import script from "./SedesFilter.vue?vue&type=script&lang=js"
export * from "./SedesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports